export default "__VITE_ASSET__39009749__"